export default __webpack_public_path__ + "static/media/user-circle.324116d2.svg";